<div
  class="social-wall-card"
  data-cy="social-wall-open-post"
  [class.inactive]="!item()?.active"
  (click)="open.emit()">
  @if (media(); as media) {
    <div class="social-wall-card__media" [ngClass]="media.type">
      @switch (media.type) {
        @case ('image') {
          <img [cropImage]="media.value | preSignedUrl | async" alt="Social wall image">
        }
        @case ('video') {
          <lib-video
            class="social-wall-card__media-video"
            [src]="(media.value | videoPresign | async) ?? ''"
            [skipContainerCheck]="true"
            (click)="$event.stopPropagation()">
          </lib-video>
        }
        @case ('audio') {
          <lib-audio-player-v2
            class="social-wall-card__media-audio"
            [src]="(media.value | preSignedUrl : entityTypeId.MEDIA : bundleType.AUDIO : fieldName.AWS_FILE | async) ?? ''"
            (click)="$event.stopPropagation()">
          </lib-audio-player-v2>
        }
      }
      <ng-container *ngTemplateOutlet="hiddenTemplate"></ng-container>
    </div>
  }
  <div class="social-wall-card__body">
    <div class="social-wall-card__user">
      <lib-user-avatar [size]="32" [user]="item().author"></lib-user-avatar>
      <div class="social-wall-card__user-details">
        <div class="social-wall-card__user-name">{{ item().author?.formattedProfileName }}</div>
        <div class="social-wall-card__user-time">{{ item().created | timeElapsed }}</div>
      </div>
      @if (contextTemplate()) {
        <button
          mat-icon-button
          class="button button--icon button--icon-extra-small library-card-context-button ml-auto"
          (click)="stopPropagation($event)"
          [matMenuTriggerFor]="matMenu"
          data-cy="library-card-context-menu">
          <lib-icon class="context-menu-icon" icon="dots-three-vertical" [bold]="true" [size]="16"></lib-icon>
        </button>
        <mat-menu class="lib-panel-menu" #matMenu="matMenu">
          <ng-container *ngTemplateOutlet="contextTemplate(); context: { item: item() }"></ng-container>
        </mat-menu>
      }
    </div>
    <div class="social-wall-card__content" [innerHtml]="item().text"></div>
    @if (item().linkToContent; as content) {
      @if (content.access_denied) {
        <div class="social-wall-card__reference social-wall-card__reference--denied">
          <lib-icon icon="lock-simple" [size]="18"></lib-icon>
          <span>{{ 'SOCIAL_WALL.content_not_available' | translate }}</span>
        </div>
      } @else {
        <div
          class="social-wall-card__reference"
          data-cy="social-wall-open-reference"
          (click)="openLinkToContent($event, content)">
          <div
            class="social-wall-card__reference-image"
            [placeholderImage]="!content.mediaImage && content.bundle"
            [cropImage]="(content.mediaImage | preSignedUrl | async) || content.image">
          </div>
          <div class="social-wall-card__reference-body">
            <span class="social-wall-card__reference-type">{{ content | bundleLabel | async }}</span>
            <span class="social-wall-card__reference-title">{{ content.title }}</span>
          </div>
        </div>
      }
    }
    <div class="social-wall-card__footer">
      <div class="social-wall-card__action-list">
        <div class="social-wall-card__action" data-cy="social-wall-like" (click)="toggleLike($event)">
          <lib-icon icon="heart" [fill]="!!item().userLiked"></lib-icon>
          {{ item().totalLikes || 0 }}
        </div>
        <div class="social-wall-card__action">
          <lib-icon icon="chat-teardrop-text"></lib-icon>
          {{ item().commentsAmount || 0 }}
        </div>
      </div>
      @if (canShowPin()) {
        <div class="social-wall-card__pin" [class.pinned]="item().pinned" [class.readonly]="!canTogglePin()">
          <button
            mat-button
            class="button button--icon"
            data-cy="social-wall-pin"
            (click)="togglePin($event)">
            <lib-icon icon="push-pin" [fill]="item().pinned"></lib-icon>
          </button>
        </div>
      }
    </div>
  </div>
  @if (!media()) {
    <ng-container *ngTemplateOutlet="hiddenTemplate"></ng-container>
  }
</div>

<ng-template #hiddenTemplate>
  @if (!item()?.active) {
    <div class="social-wall-card__hidden">
      <lib-icon icon="eye-closed" [size]="16"></lib-icon> {{ 'COMMON.hidden' | translate }}
    </div>
  }
</ng-template>
